import { Api } from "./Api";
import { User } from "../models/User";
import axios from "axios";

/** Durée de validité du profil mémorisé (ms). */
const CURRENT_USER_TTL = 30 * 1000;

// Profil courant partagé : une quinzaine de modales appellent getCurrentUser()
// à leur ouverture, chacune relançait GET user/profile.
let currentUserPromise: Promise<any> | null = null;
let currentUserLoadedAt = 0;

export class UserApi extends Api {
    constructor() {
        super("user");
    }

    getCurrentUser(): Promise<User> {
        if (
            !currentUserPromise ||
            Date.now() - currentUserLoadedAt > CURRENT_USER_TTL
        ) {
            currentUserLoadedAt = Date.now();
            currentUserPromise = axios
                .get(this.apiUrl + "profile")
                .then(function (response) {
                    return response.data.data;
                })
                .catch(function (error) {
                    currentUserPromise = null;
                    throw error;
                });
        }

        return currentUserPromise.then(function (data) {
            return new User(data);
        });
    }

    static forgetCurrentUser(): void {
        currentUserPromise = null;
    }

    changePassword(user: User, oldPassword): Promise<User> {
        return this.updateResource(user.id, user, {
            old_password: oldPassword,
        });
    }
}
